/* =====================================================================
   Balleh — wishlist (localStorage only — no server)
   Adds/removes product handles, syncs count badge, renders /account#wishlist grid.
   ===================================================================== */
(function () {
  'use strict';
  const B = window.Balleh || {};
  const t = (k) => (B.strings && B.strings[k]) || '';
  const KEY = 'balleh:wishlist';
  const read  = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (a) => localStorage.setItem(KEY, JSON.stringify(a));

  const escapeHtml = (s) => (s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fmtMoney = (cents) => (B.formatMoney ? B.formatMoney(cents) : (Number(cents) / 100).toFixed(2));
  function priceHtml(cents) {
    const sar = B.assets && B.assets.sar_symbol_url;
    const symbol = sar ? `<span class="sar-symbol"><img src="${sar}" alt="" /></span>` : '';
    return `${fmtMoney(cents)} ${symbol}`;
  }

  function setActive(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    // swap inline icon stroke→fill via inline style
    const path = btn.querySelector('path');
    if (path) {
      if (on) { path.setAttribute('fill', 'currentColor'); path.removeAttribute('stroke'); }
      else    { path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); }
    }
  }

  function refreshAll() {
    const list = read();
    for (const btn of document.querySelectorAll('[data-wishlist-toggle]')) {
      const handle = btn.getAttribute('data-wishlist-toggle');
      setActive(btn, list.includes(handle));
    }
    for (const el of document.querySelectorAll('[data-wishlist-count]')) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-wishlist-toggle');
    const list = read();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    write(list);
    refreshAll();
    // On the wishlist page the toggle is the card's remove (x) — drop the card right away.
    const grid = document.querySelector('[data-wishlist-grid]');
    if (grid && idx !== -1 && grid.contains(btn)) {
      const card = btn.closest('.product-card');
      if (card) card.remove();
      const empty = document.querySelector('[data-wishlist-empty]');
      if (empty) empty.hidden = grid.children.length > 0;
    }
  });

  // Render the wishlist grid on the wishlist page (templates/page.wishlist.json)
  async function renderGrid() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    const handles = read();
    grid.innerHTML = '';
    if (handles.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    const products = await Promise.all(handles.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    for (const p of products) {
      if (!p) continue;                    // deleted / unpublished product — skip it
      try {
        const div = document.createElement('div');
        div.innerHTML = `
          <article class="card--pink product-card">
            <a href="${p.url}" class="product-card__thumb">
              ${p.featured_image ? `<img src="${p.featured_image}" alt="" loading="lazy" />` : ''}
            </a>
            <div>
              <div class="product-card__brand">${escapeHtml(p.vendor || '')}</div>
              <h3 class="product-card__name"><a href="${p.url}">${escapeHtml(p.title)}</a></h3>
            </div>
            <div class="product-card__meta">
              <span class="product-card__price">${priceHtml(p.price)}</span>
              <button type="button" class="product-card__action-btn" data-wishlist-toggle="${p.handle}" aria-label="${escapeHtml(t('product.remove_from_wishlist') || 'إزالة')}">${'×'}</button>
            </div>
          </article>`;
        grid.appendChild(div.firstElementChild);
      } catch (err) { console.error(err); }
    }
    refreshAll();
  }

  // Loaded with `defer`, so the DOM is already parsed — run directly instead of
  // waiting for DOMContentLoaded (which may have already fired by this point).
  refreshAll();
  renderGrid();
})();
